if (!window.Eurus?.loadedScript?.has('promo-banner.js')) {
  if (window.Eurus?.loadedScript) window.Eurus.loadedScript.add('promo-banner.js');

  function fallbackCopy(text, onDone) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    if (onDone) onDone();
  }

  function initPromoBanner() {
    const banner = document.querySelector('.promo-banner-block');
    if (!banner) return;

    // Click (or keyboard) anywhere on the banner copies the promo code.
    if (!banner.dataset.copyBound) {
      banner.dataset.copyBound = '1';
      const code = banner.dataset.code || '';
      const pill = banner.querySelector('.promo-banner-code');

      const flash = () => {
        if (!pill || pill.dataset.flashing) return;
        pill.dataset.flashing = '1';
        const originalText = pill.textContent;
        const originalBg = pill.style.background;
        pill.textContent = 'COPIED!';
        pill.style.background = '#d4edda';
        setTimeout(() => {
          pill.textContent = originalText;
          pill.style.background = originalBg;
          delete pill.dataset.flashing;
        }, 2000);
      };

      const copy = () => {
        if (!code) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(flash, () => fallbackCopy(code, flash));
        } else {
          fallbackCopy(code, flash);
        }
      };

      banner.addEventListener('click', copy);
      banner.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); }
      });
    }

    const discount = parseFloat(banner.dataset.discount) || 0;
    if (!discount) return;

    const fmt = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
    };

    function updatePrices(priceCents) {
      const regularEl = banner.querySelector('.promo-banner-regular');
      const saleEl = banner.querySelector('.promo-banner-sale');
      if (regularEl) regularEl.textContent = fmt(priceCents);
      if (saleEl) saleEl.textContent = fmt(Math.round(priceCents * ((100 - discount) / 100)));
    }

    // Watch the hidden variant ID input — Eurus updates it on every variant change
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    let lastId = variantInput.value;

    const observer = new MutationObserver(() => {
      const newId = variantInput.value;
      if (newId && newId !== lastId) {
        lastId = newId;
        fetch(`/variants/${newId}.js`)
          .then(r => r.json())
          .then(v => { if (v.price) updatePrices(v.price); });
      }
    });

    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    // Also listen for programmatic value changes Eurus makes via input.value = ...
    const origDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(variantInput, 'value', {
      get() { return origDescriptor.get.call(this); },
      set(v) {
        origDescriptor.set.call(this, v);
        if (v && v !== lastId) {
          lastId = v;
          fetch(`/variants/${v}.js`)
            .then(r => r.json())
            .then(variant => { if (variant.price) updatePrices(variant.price); });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoBanner);
  } else {
    initPromoBanner();
  }

  document.addEventListener('shopify:section:load', initPromoBanner);
}
